import { Component, Input, TemplateRef, Output, EventEmitter, ViewChild, ViewEncapsulation, booleanAttribute } from '@angular/core';
import { TmModalData } from '../../entity/TmModalData';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TmModalCloseReason } from '../../entity/TmModalCloseReason';
// import { TmModalHeaderComponent } from '../tm-modal-header/tm-modal-header.component';
// import { TmModalBodyComponent } from '../tm-modal-body/tm-modal-body.component';
// import { TmModalFooterComponent } from '../tm-modal-footer/tm-modal-footer.component';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'tm-modal',
  templateUrl: './tm-modal.component.html',
  styleUrls: ['./tm-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'tmModal'
})
export class TmModalComponent {
  CLOSE_REASON = TmModalCloseReason;
  @ViewChild('modalTemp', {static: true}) modalTemp?: TemplateRef<any>;
  // @ContentChild(TmModalHeaderComponent, {static: true}) headerTemp: TmModalHeaderComponent;
  // @ContentChild(TmModalBodyComponent, {static: true}) bodyTemp: TmModalBodyComponent;
  // @ContentChild(TmModalFooterComponent, {static: true}) footerTemp: TmModalFooterComponent;
  _modalConfig: MatDialogConfig<TmModalData> = {
    width: '600px',
    position: { top: '5%' },
    maxHeight: '90%',
    panelClass: ['tm-modal'],
    closeOnNavigation: true,
    restoreFocus: true,
    autoFocus: true,
    data: new TmModalData({
      okBtnLabel: '確認',
      cancelBtnLabel: '取消'
    })
  };
  /** 彈窗設定
   * https://v16.material.angular.io/components/dialog/api#MatDialogConfig
   */
  @Input() set modalConfig(cnf: MatDialogConfig<TmModalData>|undefined) {
    if (cnf) {
      if (cnf.panelClass && cnf.panelClass.length > 0) {
        this.panelClass = cnf.panelClass as Array<string>;
        delete cnf.panelClass;
      }
      Object.assign(this._modalConfig, cnf);
    }
  }
  get modalConfig() { return this._modalConfig; }
  /** 自訂義彈窗的 css 類 */
  @Input() set panelClass(c: string[]) {
    if (!c || c.length === 0) {
      if (this.panelClass.length > 1) {
        (this.panelClass as Array<string>).splice(0, this.panelClass.length - 1);
      }
      return;
    }
    this._modalConfig.panelClass = this.panelClass.concat(c);
  }
  get panelClass() { return this._modalConfig.panelClass as Array<string>; }
  get data() { return this._modalConfig.data; }
  /** 表頭標題 */
  @Input() set title(s: string) {
    if (!this.data) { return; }
    if (s) { this.data.title = s;
    } else if (this.data.title) { this.data.title = ''; }
  }
  get title() { return this.data?.title || ''; }
  /** 主內文 */
  @Input() set message(s: string) {
    if (!this.data) { return; }
    if (s) { this.data.content = s;
    } else if (this.data.content) { this.data.content = ''; }
  }
  get message() { return this.data?.content || ''; }
  /** 確認按鈕標籤 */
  @Input() set okBtnLabel(s: string) {
    if (!this.data) { return; }
    if (s) { this.data.okBtnLabel = s;
    } else if (this.data.okBtnLabel) { this.data.okBtnLabel = ''; }
  }
  get okBtnLabel() { return this.data?.okBtnLabel || ''; }
  /** 取消按鈕標籤 */
  @Input() set cancelBtnLabel(s: string) {
    if (!this.data) { return; }
    if (s) { this.data.cancelBtnLabel = s;
    } else if (this.data.cancelBtnLabel) { this.data.cancelBtnLabel = ''; }
  }
  get cancelBtnLabel() { return this.data?.cancelBtnLabel || ''; }
  /** 是否顯示表頭的關閉叉叉按鈕 */
  @Input({transform: booleanAttribute}) set showClose(b: boolean) {
    if (!this.data) { return; }
    if (b !== undefined && b !== null) { this.data.showClose = b; }
  }
  get showClose() { return this.data?.showClose || false; }
  /** 顯示於表頭的關閉叉叉按鈕語意標籤 */
  @Input() closeBtnAriaLabel: string = 'Close';
  /** 確認後關閉事件完成 */
  @Output() afterConfirm: EventEmitter<void> = new EventEmitter<void>();
  /** 非確認關閉事件完成 */
  @Output() afterCancel: EventEmitter<void> = new EventEmitter<void>();
  mdRef?: MatDialogRef<TemplateRef<any>, TmModalCloseReason>;
  isOpened = false;

  constructor(public dialog: MatDialog) { }

  open(): Observable<void> {
    this.mdRef = this.dialog.open(this.modalTemp as TemplateRef<any>, this.modalConfig);
    this.isOpened = true;
    this.listenAfterCloseEvent();
    return this.mdRef.afterOpened();
  }

  protected listenAfterCloseEvent() {
    if (!this.mdRef) { return; }

    this.mdRef.afterClosed().subscribe(v => {
      this.isOpened = false;
      switch (v) {
        case TmModalCloseReason.SUBMIT:
          this.afterConfirm.emit();
          break;
        case TmModalCloseReason.CLOSE:
          this.afterCancel.emit();
          break;
        default: // undefined, from backdrop click.
          this.afterCancel.emit();
          break;
      }
    });
  }

  close(reason: TmModalCloseReason = TmModalCloseReason.CLOSE): Observable<TmModalCloseReason|undefined> {
    if (!this.mdRef) { return of(undefined); }

    this.mdRef.close(reason);
    return this.mdRef.afterClosed();
  }
}
